import PropTypes from "prop-types";
import React from "react";

import { AVAILABLE, AWAY, BUSY } from "@/constants/event";

import { getPatientSessionStatus } from "../../utils/event";
import { hasOverlap } from "../../utils/dates";

import { Availability } from "./Availability";
import { AwayTime } from "./AwayTime";
import { BusyEvent } from "./BusyEvent";
import { CalendarEventBody, UnconfirmedCalendarEventBody } from "./CalendarEvent";
import { PatientSession } from "./PatientSession";

import "./styles.scss";

const eventToComponent = (event, availability) => {
  if (event.details?.event_type === AWAY) {
    return (
      <AwayTime
        details={event.details}
        endTime={event.endTime}
        label={event.details?.label}
        position={event.position}
        startTime={event.startTime}
      />
    );
  } else if (event.details?.event_type === AVAILABLE) {
    return (
      <Availability
        details={event.details}
        endTime={event.endTime}
        position={event.position}
        startTime={event.startTime}
      />
    );
  } else if (event.details?.event_type === BUSY) {
    return (
      <BusyEvent
        details={event.details}
        endTime={event.endTime}
        position={event.position}
        startTime={event.startTime}
      />
    );
  }
  // if the event has a patient name then it is a patient event
  else if (event.details?.patient_name) {
    const status = getPatientSessionStatus(event.details);
    const overlappingAvailabilitySlots = availability
      .filter((availableSlot) => {
        return hasOverlap(
          availableSlot.startTime,
          availableSlot.endTime,
          event.startTime,
          event.endTime,
        );
      })
      .map((availableSlot) => {
        return availableSlot.details;
      });

    return (
      <PatientSession
        availability={overlappingAvailabilitySlots}
        details={event.details}
        endTime={event.endTime}
        key={event.startTime + event.details?.patient_preferred_name}
        patientName={event.details?.patient_name ?? "N/A"}
        patientPreferredName={event.details?.patient_preferred_name}
        position={event.position}
        startTime={event.startTime}
        status={status}
      />
    );
  } else if (event.details?.unconfirmed === true) {
    return <UnconfirmedCalendarEventBody position={event.position} />;
  }
};

const EventGroup = ({ eventGroup }) => {
  const { events, position } = eventGroup;
  const availabilityInGroup = eventGroup.events.filter(
    (event) => event.details.event_type === AVAILABLE,
  );

  if (events.length - availabilityInGroup.length > 3) {
    return (
      <CalendarEventBody
        className="EventGroup-overflow__body"
        details={events.map((event) => event.details)}
        position={position}
      >
        <p className="EventGroup-overflow__title">
          <b>{events.length} events</b> - select to see all
        </p>
      </CalendarEventBody>
    );
  }

  return (
    <>
      {events.map((event, index) => (
        <React.Fragment key={event.details?.id || event.startTime || index}>
          {eventToComponent(event, availabilityInGroup)}
        </React.Fragment>
      ))}
    </>
  );
};

EventGroup.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  position: PropTypes.object,
};

export { EventGroup };
